module.exports = __webpack_public_path__ + "static/assets/c9449624da5923bca9580048d74da7bc.png";